import { createApp } from 'vue';
import ArwToWebpConverter from '../Components/ArwToWebpConverter.vue';

const root = document.getElementById('arw-to-webp-converter');
if (root) {
  createApp(ArwToWebpConverter).mount('#arw-to-webp-converter');
}
